<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <table class="table">
          <thead>
            <tr>
              <th class="text-left">
                Документ
              </th>
              <th class="text-left"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="doc in list" :key="doc.id">
              <td>{{ doc.name }}</td>

              <td align="right">
                <v-btn
                  @click="generate({ template_id: doc.id, entity_type: doc.entity_type, entity_id: customerId, name: doc.name })"
                  >Сгенерировать</v-btn
                >
              </td>
            </tr>
          </tbody>
        </table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import { getDocuments, generateDocument } from "./agreements.services.js";
export default Vue.extend({
  components: {},

  props: {},

  data() {
    return {
      list: [],
    };
  },
  computed: {
    customerId() {
      return this.$store.state.customer.id;
    },
  },
  methods: {
    async generate(data) {
      try {
        await generateDocument(data);
      } catch (error) {
        console.error(`Ошибка генерации документа =>`, error);
        this.$notify.showMessage("Ошибка генерации документа", "error");
      }
    },
  },
  async created() {
    this.list = await getDocuments();
  },
});
</script>
<style scoped>
.table {
  width: 100%;
  border-spacing: 0;
}
.table th {
  background: #bebebe;
  padding: 10px 5px;
}
.table td {
  padding: 5px 0;
  border-bottom: 1px solid #333;
}
</style>
